import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import CompanyDocs from "../CompanyDocs";
import CompanyITR from "../CompanyITR";
import CompanyBankStatement from "../CompanyBankStatement";
import BusinessSummarySheet from "../BusinessSummarySheet";

export class LeadsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accordianList: [],
        };
    }
    componentDidMount() {
        this.setState({
            accordianList: [
                {
                    title: "Entity Documents",
                    description: <CompanyDocs />,
                },
                { title: "Company's ITR", description: <CompanyITR /> },
                {
                    title: "Bank Statement",
                    description: <CompanyBankStatement />,
                },
                {
                    title: "Business Summary Sheet",
                    description: <BusinessSummarySheet />,
                },
            ],
        });
    }
    render() {
        return (
            <AppWrapper title="Leads View" back="Leads" backlink="/app/leads" >
                <div className="row">
                    <div className="container-fluid paper_container">
                        <AppAccordian
                            data={this.state.accordianList?.map((o, i) => ({
                                Title: o.title && (() => o.title),
                                Content: o.description && (() => o.description),
                            }))}
                        ></AppAccordian>
                    </div>
                </div>
            </AppWrapper>
        );
    }
}

export default LeadsView;